import React, { useEffect, useState } from "react";
import Bowser from "bowser";
import "./classes/OldBrowserAlert.css";

function OldBrowserAlert() {
  const [showAlert, setShowAlert] = useState(false);
   
  useEffect(() => {
    const alreadyShown = localStorage.getItem("oldSafariWarningShown");

    if (alreadyShown) {

      setShowAlert(false);
      return;
    }
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserName = browser.getBrowserName();
    const version = parseFloat(browser.getBrowserVersion());

    if (
      browserName &&
      browserName.includes("Safari") &&
      version < 16
    ) {
      setShowAlert(true);
    }
  }, []);
 const handleClose = () => {
    localStorage.setItem("oldSafariWarningShown", "true");
    setShowAlert(false);
  };
  if (!showAlert) return null;

  return (
    <div className="browser-warning-overlay">
      <div className="browser-warning-modal">
        
        <p>
          Having trouble? Your browser may be too old to load this page. Update your browser to continue or reach us at (503) 445-7105.
        </p>
        <button onClick={handleClose}>OK</button>
      </div>
    </div>
  );
}

export default OldBrowserAlert;